import {
  combineReducers,
  configureStore,
  type Reducer,
} from "@reduxjs/toolkit";
import userSelectionSlice from "./slices/userSelection/userSelection";
import userDetailSlice from "./slices/userDetail/userDetailSlice";
import brandsSlice from "./slices/brands/brandsSlice";
import marketsSlice from "./slices/markets/marketsSlice";
import filtersSlice from "./slices/filters/filtersSlice";
import segmentsSlice from "./slices/segments/segmentsSlice";
import CONFIG from "@/config";
// JS assistant reducer from geo-ui (ported as-is)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import chatReducer from "@/components/AIAssistant/state/chatReducer";
import featureStatusSlice from "./slices/featureStatus/featureStatusSlice";
import attributeLabelsSlice from "./slices/attributeLabels/attributeLabelsSlice";
import questionsSlice from "./slices/questions/questionsSlice";
import fileDownloadSlice from "./slices/fileDownload/fileDownloadSlice";
import ingestionSlice from "./slices/ingestionTime/ingestionTimesSlice";
import bootstrapDataStatusSlice from "./slices/bootstrapDataStatus/bootstrapDataStatusSlice";
import brandsOrderMappingSlice from "./slices/brandsOrderMapping/brandsOrderMappingSlice";
import screenLevelSelectionSlice from "./slices/screenLevelSelection/screenLevelSelection";

const activeGroupReducer: Reducer<{
  brands: ReturnType<typeof brandsSlice>;
  markets: ReturnType<typeof marketsSlice>;
  filters: ReturnType<typeof filtersSlice>;
  segments: ReturnType<typeof segmentsSlice>;
  attributeLabels: ReturnType<typeof attributeLabelsSlice>;
  questions: ReturnType<typeof questionsSlice>;
  ingestionTime: ReturnType<typeof ingestionSlice>;
  bootstrapDataStatus: ReturnType<typeof bootstrapDataStatusSlice>;
  brandsOrderMapping: ReturnType<typeof brandsOrderMappingSlice>;
}> = combineReducers({
  brands: brandsSlice,
  markets: marketsSlice,
  filters: filtersSlice,
  segments: segmentsSlice,
  attributeLabels: attributeLabelsSlice,
  questions: questionsSlice,
  ingestionTime: ingestionSlice,
  bootstrapDataStatus: bootstrapDataStatusSlice,
  brandsOrderMapping: brandsOrderMappingSlice,
});

export const store = configureStore({
  reducer: {
    activeGroup: activeGroupReducer,
    featureStatus: featureStatusSlice,
    userSelection: userSelectionSlice,
    userDetail: userDetailSlice,
    fileDownload: fileDownloadSlice,
    screenLevelSelection: screenLevelSelectionSlice,
    // Assistant chat state (JS reducer)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: String(CONFIG.env) !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
